import { getVapidPublicKey, subscribePush } from './api/api';

// El navegador espera la applicationServerKey como Uint8Array, pero el servidor la manda
// en base64url (formato estándar de VAPID) — hay que convertirla a mano, no existe un
// helper nativo para esto.
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

// Se llama una vez que el usuario ya tiene sesión activa (ver App.js). El navegador es el
// único que puede pedir el permiso de notificaciones — nunca se puede "activar por default"
// en silencio, así que esto dispara ese diálogo automáticamente en vez de esconder la
// opción en un ajuste que nadie encontraría. Si el usuario ya lo bloqueó antes, o el
// navegador no soporta push (Safari viejo, por ejemplo), no hace nada y no truena el resto
// de la app.
export async function ensurePushSubscription() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
  if (Notification.permission === 'denied') return;

  try {
    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      if (Notification.permission !== 'granted') {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;
      }
      const { data } = await getVapidPublicKey();
      if (!data.publicKey) return; // VAPID aún no configurado en el servidor (.env)
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.publicKey),
      });
    }

    await subscribePush(subscription.toJSON());
  } catch (err) {
    console.error('Error activando notificaciones push:', err);
  }
}
